import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentSelectedConsequenceDto extends EpimsBaseEntityDto {
    
   EventTypeId: string;
   ConsequenceId: string;
   ConsequenceName: string;  
   
    
   IncidentTrackingNo: string;
    

}